import React from 'react'
import PropTypes from 'prop-types'
import { TextArea as ScufTextArea } from '@scuf/common'
import { useField, useFormikContext } from 'formik'

const TextArea = ({
  name,
  setMask,
  ...rest
}) => {
  const [field, meta, helpers] = useField(name)
  const { submitCount } = useFormikContext()

  const handleChange = (meta, newValue, fieldName) => {
    if (meta.initialValue !== newValue) {
      setMask(oldMask => !oldMask.includes(fieldName)
        ? [...oldMask, fieldName]
        : [...oldMask])
    } else if (meta.initialValue === newValue) {
      setMask(oldMask => oldMask.filter(p => p !== fieldName))
    }
  }
  return (
    <ScufTextArea
      error={(meta.touched || submitCount > 0) && meta.error}
      id={name}
      onBlur={() => helpers.setTouched(true)}
      onChange={(value) => {
        handleChange(meta, value, name)
        helpers.setValue(value)
      }}//{helpers.setValue}
      value={field.value}
      {...rest}
    />
  )
}

TextArea.propTypes = {
  name: PropTypes.string.isRequired
}

export default TextArea
